export const Search = () => {
  return (
    <button title="Search">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
      >
        <path
          d="M15.8333 15.8333L12.9168 12.9166M15 7.91665C15 11.8287 11.8287 15 7.91668 15C4.00466 15 0.833344 11.8287 0.833344 7.91665C0.833344 4.00463 4.00466 0.833313 7.91668 0.833313C11.8287 0.833313 15 4.00463 15 7.91665Z"
          stroke="white"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  );
};
